import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { ProjectState } from '../core/store/reducers/project';
import { getCurrentProject } from '@completion/selectors';
import { UserAccessService } from '../core/services/user-access.service';
import { getRole } from '@completion/selectors';

@Component({
  selector: 'app-side-navigation',
  templateUrl: 'side-navigation.component.html',
  styleUrls: ['side-navigation.component.scss'],
  standalone: false,
})
export class SideNavigationComponent {
  isOpen: boolean;

  @Input()
  isOnline: boolean;
  displaySiteFilter = false;
  displayTaskFilter = true; // defalut to true, as this is the default for all projects
  displayReports = true;
  displaySupplierModule = true;
  hasAccessToSupplierModule = false;
  hasAccessToBatchModule = false;
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private readonly store: Store<ProjectState>,
    private readonly router: Router,
    private readonly userAccess: UserAccessService,
  ) {
    if (window.localStorage.getItem('sidebarOpen') === undefined) {
      window.localStorage.setItem('sidebarOpen', this.isOpen.toString());
    } else {
      this.isOpen = window.localStorage.getItem('sidebarOpen') === 'true';
    }

    this.store
      .select(getRole)
      .pipe(takeUntil(this.destroy$))
      .subscribe((role) => {
        if (role === 'VENDOR') {
          this.displaySiteFilter = false;
          this.displayTaskFilter = false;
          this.displayReports = false;
          this.displaySupplierModule = false;
        }
      });
    this.userAccess.canOperateMCP$.pipe(takeUntil(this.destroy$)).subscribe((canOperate) => (this.hasAccessToBatchModule = canOperate));
    this.userAccess.canWriteProjectData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((canWrite) => (this.hasAccessToSupplierModule = canWrite && this.displaySupplierModule));

    this.store
      .select(getCurrentProject)
      .pipe(takeUntil(this.destroy$))
      .subscribe((p) => {
        if (p && this.isOnline) {
          const projectConfig = p.config.find((c) => c.name === 'DISPLAY_FILTER_TREE_ON_SITE');
          this.displaySiteFilter = projectConfig?.value === 'true' && !this.userAccess.isVendor;

          const projectConfigMcSite = p.config.find((c) => c.name === 'DISPLAY_FILTER_TREE_ON_MC_SITE');
          this.displaySiteFilter = projectConfigMcSite
            ? projectConfigMcSite.value === 'true' && !this.userAccess.isVendor
            : this.displaySiteFilter;

          const projectConfigTask = p.config.find((c) => c.name === 'DISPLAY_FILTER_TREE_ON_TASK');
          this.displayTaskFilter = projectConfigTask ? projectConfigTask.value === 'true' && !this.userAccess.isVendor : true;
        }
      });
  }

  loadDownloads() {
    this.router.navigate(['downloads']);
    return true;
  }

  loadReports() {
    this.router.navigate(['reports']);
    return true;
  }

  loadDashboard(): boolean {
    this.router.navigate(['dashboard']);
    return true;
  }

  toggleOpen(): void {
    this.isOpen = !this.isOpen;
    window.localStorage.setItem('sidebarOpen', this.isOpen.toString());
  }

  loadSupplierModule() {
    this.router.navigate(['supplier']);
  }

  loadBatchModule() {
    this.router.navigate(['batch']);
  }
}
